import React from 'react';

export const ViewContext = React.createContext();
ViewContext.displayName = 'ViewContext';
